import React, {useEffect, useState} from 'react';

import Box from "@mui/material/Box";
import {IEvent} from "./Buxliest";
import Event from "./Event";

export interface IEventScrollerProps {
  events: IEvent[];
  registerSuccessCallback: () => void,
}

const EventScroller = (props: IEventScrollerProps) => {
  const [event, setEvent] = useState<IEvent>(null);
  const [selected, setSelected] = useState<number>(null);


  const addAttendeeSuccess = () => {
    props.registerSuccessCallback();
    setEvent(null);
    setSelected(null);
  }

  function handleClick(index: number, event: IEvent) {
    if (index == selected) {
      setEvent(null);
      setSelected(null);
    } else {
      setEvent(event);
      setSelected(index);
    }
  }

  return (
    <>
      <Box className="pt-4 overflow-x-auto flex flex-row">
        {props.events.map((event, i) =>
          <div className="flex flex-col flex-shrink-0 mr-2 ">
            <Box
              className={`h-[150px] w-auto flex cursor-pointer rounded-sm overflow-hidden  ${i == selected ? "border-2 border-secondary-500" : ""}`}
              onClick={() => handleClick(i, event)}>
              <img className="h-[150px] w-auto"
                   src={"/drimage/160/210/" + event.field_medium.drupal_internal__fid + "/-/jpg"}
                   alt={event.title} title={event.title}></img>
            </Box>
            <div className={`flex self-center border-solid border-b-[16px] border-x-transparent border-x-[16px] border-t-0   ${i == selected ? "border-secondary-500" : "border-transparent"}`}></div>
          </div>

        )}
      </Box>
      {event && (
        <Box className="mb-8 p-4 bg-gray-100 rounded-md border-secondary-500 border-t-2 border-solid">
          <Event event={event} registerSuccessCallback={addAttendeeSuccess}></Event>
        </Box>
      )}

    </>
  );
};
export default EventScroller;
